const firebaseConfig = {
    apiKey: "AIzaSyCp3agMeDSOKLooVNZhPUwXFkaN1sv-a5Y",
    authDomain: "volunteer-network-491bb.firebaseapp.com",
    databaseURL: "https://volunteer-network-491bb.firebaseio.com",
    projectId: "volunteer-network-491bb",
    storageBucket: "volunteer-network-491bb.appspot.com",
    messagingSenderId: "907151951436",
    appId: "1:907151951436:web:85a60a5c2c26a8fd7e56e9"
  };
  export default firebaseConfig;